import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import { Theme } from '@mui/material';
import { ChevronDown } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';

const CIRCLE_SIZE = 32;

interface RachelScrollToBottomButtonProps {
  newMessagesCount: number;
  onScrollToBottom: () => void;
}

const getSurfaceStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.background.paper,
  borderColor: theme.palette.custom.border.primary,
  color: theme.palette.text.secondary,
});

const RachelScrollToBottomButton = ({
  newMessagesCount,
  onScrollToBottom,
}: RachelScrollToBottomButtonProps) => {
  const { translate } = useTranslation();

  const hasNewMessages = newMessagesCount > 0;

  return (
    <Button
      variant="outlined"
      size="small"
      testId="rachel-scroll-to-bottom"
      aria-label={hasNewMessages ? undefined : translate(LangEnum.RACHEL_SCROLL_TO_BOTTOM)}
      sx={(theme) => ({
        ...getSurfaceStyles(theme),
        gap: 0.5,
        ...(hasNewMessages
          ? { minWidth: 160 }
          : { minWidth: CIRCLE_SIZE, width: CIRCLE_SIZE, padding: 0 }),
      })}
      onClick={onScrollToBottom}
    >
      {hasNewMessages && translate(LangEnum.RACHEL_NEW_MESSAGE, { count: newMessagesCount })}
      <Icon icon={ChevronDown} size="md" />
    </Button>
  );
};

export default RachelScrollToBottomButton;
